<template>
  <div class="school-list-page app-content">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.school.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-create">
      <app-filter-button
        :active.sync="activeFilter"
      />
    </div>

    <app-school-list-filter v-if="activeFilter" />

    <div class="app-content-page">
      <app-school-list-table></app-school-list-table>
    </div>
  </div>
</template>

<script>
import SchoolListFilter from '@modules/school/components/school-list-filter.vue';
import SchoolListTable from '@modules/school/components/school-list-table.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'app-school-list-page',

  components: {
    [SchoolListFilter.name]: SchoolListFilter,
    [SchoolListTable.name]: SchoolListTable,
  },

  data() {
    return {
      activeFilter: false,
    };
  },
  computed: {
    ...mapGetters({
      rows: 'school/list/rows',
      loading: 'school/list/loading',
    }),
  },
};
</script>

<style>
</style>
